import { httpClient } from '../http/httpClient'
import { PartnerType } from '@/app/utils/partners.enum'

export type MakeProposalRequest = {
  name: string
  phone: string
  document: string
  description?: string
  vehicle: string
  model_id: string
  year: string
  plate: string
  cityId: number
  cityName: string
  stateId: number
  stateName: string
  customerId: string
  pin?: string
}

export type MakeProposalResponse = {
  _id: string
  contract: string
  reason_to_cancel: string
  value: number
  status: string
  statusAt: string
  history: any[]
  seller: string
  customer: string
  team: string
  table: string
  createdAt: string
  updatedAt: string
  __v: number
}

export async function makeProposal(
  proposal: MakeProposalRequest,
): Promise<MakeProposalResponse> {
  const { data } = await httpClient
    .post<MakeProposalResponse>('/salvcar', proposal, {
      journey: PartnerType.SALVCAR,
    })
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
